export enum CurrencyDisplayStyle {
    Default = 0,            // same as Integer     (with default currency symbol)
    Integer = 1,            // zero decimal places (with default currency symbol)
    Decimal = 2,           //  2 decimal places    (with default currency symbol)
    Custom = 3
}